<template>
<div>
  <snowflake-search-list context="subscription-box-production-batch"
    :service="subscriptionBoxProductionBatchService"
    defaultSortColumn="id"
    defaultSortDirection="DESC"
    :defaultTableFilters="tableFilters"
    :search-options="searchOptions">
    <template slot="action">
      <el-dropdown
        split-button
        type="primary"
        trigger="click"
        @click="goToNewBatch()"
        @command="goToNewBatch">
        Novo
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="beta">Novo na página beta</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
    <template slot="tableRows">

      <!-- ID -->
      <el-table-column prop="id" label="ID" width="72" sortable></el-table-column>

      <!-- Status -->
      <el-table-column column-key="status" prop="status" label="Status" width="72" align="center" :filters="statusFilters">
        <template slot-scope="scope">
          <el-tooltip :content="status[scope.row.status] ?? scope.row.status" placement="top">
            <div :class="`status-icon status-${scope.row.status}`"></div>
          </el-tooltip>
        </template>
      </el-table-column>

      <!-- Name -->
      <el-table-column prop="name" label="Nome" :show-overflow-tooltip="true" sortable></el-table-column>

      <!-- Edition -->
      <el-table-column prop="edition" label="Edição" width="120" sortable></el-table-column>

      <!-- Pedidos -->
      <el-table-column prop="orders" label="Nº de Pedidos" width="160">
        <template slot-scope="scope">
          {{ scope.row.orders.length }}
        </template>
      </el-table-column>

      <!-- Created At -->
      <el-table-column prop="createdAt" label="Data de Criação" width="160" sortable>
        <template slot-scope="scope">
          <span>{{ fromSystemDate(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>

    </template>
  </snowflake-search-list>

   <iframe
      :src="availableOrdersChartUrl"
      frameborder="0"
      height="480"
      style="width: 100%; margin-top: 32px"
      allowtransparency
  ></iframe>
</div>
</template>

<script>
import moment from 'moment';

import SnowflakeService from '@/services/SnowflakeService';
import SubscriptionBoxProductionBatchService from '@/services/fulfillment/SubscriptionBoxProductionBatchService';

import SnowflakeSearchList from '@/components/list/SearchList.vue';

export default {
  name: 'subscription-box-production-batch-search-list',
  components: {
    SnowflakeSearchList,
  },
  props: {
    type: {
      type: String,
      default: 'STANDARD',
    },
  },
  data() {
    return {
      subscriptionBoxProductionBatchService: SubscriptionBoxProductionBatchService,

      loading: {
        availableOrders: true,
      },

      availableOrders: 0,

      availableOrdersChartUrl: null,
      status: {
        PLANNED: 'Planejado',
        PRODUCTS_SELECTED: 'Produtos selecionados',
        IN_PRODUCTION: 'Em produção',
        READY_TO_POST: 'Pronto para postagem',
        IN_TRANSIT: 'Em trânsito',
        DELIVERED: 'Entregue',
      },
      tableFilters: {
        status: ['PLANNED', 'PRODUCTS_SELECTED', 'IN_PRODUCTION', 'READY_TO_POST']
      }
    };
  },
  computed: {
    searchOptions() {
      return {
        filters: [`type:${this.type}`]
      };
    },
    statusFilters() {
      return Object.entries(this.status).map(([value, text]) => ({ text, value }));
    },
  },
  async created() {
    try {
      const request = {
        resource: {
          question: 1109
        },
        params: {
          productionBatchType: [this.type]
        }
      };

      const response = await SnowflakeService.generateMetabaseEmbedToken(request);

      this.availableOrdersChartUrl = `https://metabase.uptack.io/embed/question/${response.token}#bordered=false&titled=false`;
    } finally {
      this.loading.availableOrders = false;
    }
  },
  methods: {
    fromSystemDate(value) {
      return value ? moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY') : null;
    },
    goToNewBatch(command) {
      this.$router.push({
        name: command === 'beta'
          ? 'subscription-box-production-batch-new-beta'
          : 'subscription-box-production-batch-new',
        params: { type: this.type },
      });
    },
  },
};
</script>
<style lang="sass">
.status-icon
  display: inline-block
  color: rgba(0, 0, 0, 0)

  &::before
    content: '\25CF '
    height: 12px
    width: 12px

  &.status-PLANNED
    color: #C0C0C0

  &.status-PRODUCTS_SELECTED
    color: rgb(249, 212, 92)

  &.status-IN_PRODUCTION
    color: orange

  &.status-READY_TO_POST
    color: rgb(136, 191, 77)

  &.status-IN_TRANSIT
    color: rgb(152, 217, 217)

  &.status-DELIVERED
    color: rgb(80, 158, 227)
</style>
